export const getBase64Content = (str?:string) => str ? Buffer.from(str, 'utf-8').toString('base64') : Buffer.from('nanai', 'binary').toString('base64')
